<mat-dialog-content class="justify-content-between overflow-hidden" style="max-height:inherit;">
    <div class="d-flex justify-content-between">
        <h5 class="fw-semibold">Sensordaten vom Gerät:&nbsp;{{ deviceName }}</h5>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
            (click)="onCloseDialogClicked()">
    </div>
    <div class="d-flex justify-content-between px-4 py-2">
        <div class="d-flex justify-content-center align-items-center">
            Von vor&nbsp;
            <input class="ms-1 me-1 form-control rounded-0 form-control-sm" style="width: 70px" type="number"
                [(ngModel)]="fromDate" (ngModelChange)="setFromDate(fromDate)" min="1" max="14">
                &nbsp;Tagen&nbsp;bis zu&nbsp;
            <input class="ms-1 me-1 form-control rounded-0 form-control-sm" style="width: 70px" type="number"
                [(ngModel)]="toDate" (ngModelChange)="setToDate(toDate)" min="0" max="13"> 
                &nbsp;Tagen
        </div>
        <div class="d-flex justify-content-center">
            <div class="avs-route-station-settings-dropdown-container justify-content-between mx-2">
                <div [ngClass]="isChannelDropdownOpen ? 'border-danger' : ''"
                    class="border d-flex justify-content-between" role="button"
                    (click)="onChannelDropdownClicked()">
                    <div class="ms-2 p-1">{{ selectedChannel.name }}</div>
                    <img *ngIf="!isChannelDropdownOpen" class="me-2" src="assets/icons/caret-down.svg"
                        alt="caret-down open select">
                    <img *ngIf="isChannelDropdownOpen" class="me-2" src="assets/icons/caret-up.svg"
                        alt="caret-up close select">
                </div>
                <avs-dropdown [selectInput]="channelSelect" [activeItem]="selectedChannel"
                    (onItemClicked)="onChannelItemClicked($event)" [isHeaderActive]="false"
                    *ngIf="isChannelDropdownOpen" class="avs-route-station-settings-dropdown-container">
                </avs-dropdown>
            </div>
            <div class="avs-route-station-settings-dropdown-container justify-content-between mx-2">
                <div [ngClass]="isIntervallDropdownOpen ? 'border-danger' : ''"
                    class="border d-flex justify-content-between" role="button"
                    (click)="onIntervallDropdownClicked()">
                    <div class="ms-2 p-1">{{ selectedIntervall.name }}</div>
                    <img *ngIf="!isIntervallDropdownOpen" class="me-2" src="assets/icons/caret-down.svg"
                        alt="caret-down open select">
                    <img *ngIf="isIntervallDropdownOpen" class="me-2" src="assets/icons/caret-up.svg"
                        alt="caret-up close select">
                </div>
                <avs-dropdown [selectInput]="intervallSelect" [activeItem]="selectedIntervall"
                    (onItemClicked)="onIntervallItemClicked($event)" [isHeaderActive]="false"
                    *ngIf="isIntervallDropdownOpen" class="avs-route-station-settings-dropdown-container">
                </avs-dropdown>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <button (click)="removeData()" class="btn rounded-0 btn-outline-success btn-sm"> Update
            </button>
        </div>
    </div>
    <div class="d-flex justify-content-left m-4 fw-semibold">{{laneDescription}}
    </div>
    <div class="h-75 overflow-scroll">       
        <div class="h-100">
            <canvas id="SpeedChart"></canvas>
        </div>
    </div>
</mat-dialog-content>
<div mat-dialog-actions class="d-flex justify-content-between m-4">
    <button (click)="exportChart()" class="btn rounded-0 btn-outline-success btn-sm"> Export
    </button>
    <button (click)="onCloseDialogClicked()" class="btn rounded-0 btn-outline-danger btn-sm">
        Schließen
    </button>
</div>



<!-- 
            <div class="chart-container">
                <canvas id="SpeedChart"></canvas>
            </div>

<div class="d-flex justify-content-left m4 fw-semibold">{{laneDescription}}
        </div>
-->